import { useI18n, useRouter } from '@popety_io/popety-io-lib'
import { noiseOptions } from '../../../../../../utils/thematic/glossary/noiseOptions'
import LegendSelector from '../../../../../../components/LegendSelector'

const NoiseMapContent = () => {
  const { t } = useI18n()
  const noiseOption = noiseOptions(t)
  const { query } = useRouter()

  return (
    <div>
      <LegendSelector
        options={noiseOption}
        legends={noiseOption?.[0]?.legend}
        value={query.noiseLayer || 'noise-road-day-v1'}
        keyValue="noiseLayer"
        legendValue="noiseLegend"
      />
    </div>
  )
}

export default NoiseMapContent
